// removed by extract-text-webpack-plugin
module.exports = {"button":"_1JHqy","page":"_3NN5u","thumb":"_1F5wU","info":"_2j33D","icons":"_22zIg","iconButton":"I6jda","outline":"_3XEpn","image":"_3-gzl","keyword":"_1fpDy","infoList":"mqgfC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Image.css
// module id = 856
// module chunks = 0